export default "__VITE_ASSET__db54c994__"